<template>
    <div>
        <div class="wrap">
            <div class="top">
                <div class="course-content">
                    <div class="course-nav-box">
                        <div class="course-nav-row clearfix">
                            <span class="hd l">类型：</span>
                            <div class="bd">
                                <ul class="">
                                    <li class="course-nav-item" v-bind:class="{ on: isLx == '全部' }">
                                        <a href="javascript:void(0);" @click="setisLx('全部')">全部</a>
                                    </li>
                                    <li class="course-nav-item" v-bind:class="{ on: isLx == '安全管理人员' }">
                                        <a href="javascript:void(0);" @click="setisLx('安全管理人员')">安全管理人员</a>
                                    </li>
                                    <li class="course-nav-item" v-bind:class="{ on: isLx == '特种作业人员' }">
                                        <a href="javascript:void(0);" @click="setisLx('特种作业人员')">特种作业人员</a>
                                    </li>
                                    <li class="course-nav-item" v-bind:class="{ on: isLx == '特种设备作业人员' }">
                                        <a href="javascript:void(0);" @click="setisLx('特种设备作业人员')">特种设备作业人员</a>
                                    </li>
                                    <li class="course-nav-item" v-bind:class="{ on: isLx == '非高危行业' }">
                                        <a href="javascript:void(0);" @click="setisLx('非高危行业')">非高危行业</a>
                                    </li>
                                    <li class="course-nav-item" v-bind:class="{ on: isLx == '职业健康安全培训' }">
                                        <a href="javascript:void(0);" @click="setisLx('职业健康安全培训')">职业健康安全培训</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="course-nav-row course-nav-skills clearfix">
                            <div class="js-course-skills course-skills-box">
                                <span class="hd l">类别：</span>
                                <div class="bd">
                                    <ul class="">
                                        <li class="course-nav-item" v-bind:class="{ on: isLb == '全部' }">
                                            <a href="javascript:void(0);" @click="setisLb('全部')">全部</a>
                                        </li>
                                        <li class="course-nav-item" v-bind:class="{ on: isLb == key }"
                                            v-for="(value, key) in towworks">
                                            <a href="javascript:void(0);" @click="setisLb(key,value)">{{key}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <courseproduct v-bind:showworks="showworks"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import Allcount from "./allcount";
    import Courseproduct from "./courseproduct";

    export default {
        name: "course",
        components: {
            Courseproduct,
            Allcount,
            axios,
        },
        data() {
            return {
                isLx: '全部',
                isLb: '全部',
                //所有工种
                allworks: [],
                //所有二级工种
                towworks: [],
                //要展示的数据
                showworks: [],
            }
        },
        methods: {
            //设置类型
            setisLx(sty) {
                if (sty == '全部') {
                    this.isLb = sty;
                    this.towworks = this.getbannerwork(this.allworks);
                    this.showworks = this.allworks;
                } else {
                    var linshi = [];
                    for (var num in this.allworks) {
                        if (this.allworks[num].gzleixing == sty) {
                            linshi.push(this.allworks[num]);
                        }
                    }
                    this.towworks = this.getbannerwork(linshi);
                    this.showworks = linshi;
                    this.isLb = '全部';
                }
                this.isLx = sty;
            },
            setisLb(sty, obj) {
                if (sty != '全部') {
                    this.isLx = obj[0].gzleixing;
                    this.showworks = obj;
                } else {
                    if (this.isLx == '全部') {
                        this.towworks = this.getbannerwork(this.allworks);
                        this.showworks = this.allworks;
                    } else {
                        var linshi = [];
                        for (var num in this.allworks) {
                            if (this.allworks[num].gzleixing == this.isLx) {
                                linshi.push(this.allworks[num]);
                            }
                        }
                        this.towworks = this.getbannerwork(linshi);
                        this.showworks = linshi;
                    }
                }
                this.isLb = sty;
            },
            getdatascesehi() {
                axios.post("/Api/getworks").then(res => {
                    if (res.statusText == "OK") {
                        this.allworks = res.data.data;
                        this.showworks = res.data.data;
                        this.towworks = this.getbannerwork(this.allworks);

                    }
                });
            },
            getbannerwork(dta) {
                var wode = {};
                for (var obj in dta) {
                    if (wode[dta[obj].gzleibie]) {
                        wode[dta[obj].gzleibie].push(dta[obj]);
                    } else {
                        wode[dta[obj].gzleibie] = [dta[obj]];
                    }
                }
                return wode;
            },

        },
        mounted: function () {
            this.getdatascesehi();

        },

    }
</script>

<style>
    .wrap {
        width: 100%;
        background-color: #fff;
        padding-bottom: 12px;
        box-shadow: 0 4px 8px 0 rgba(28, 31, 33, .1);
    }

    .wrap .top {
        max-width: 1386px;
        margin: auto;
    }

    /*.wrap .top .course-top {*/
    /*clear: both;*/
    /*border-bottom: 1px solid rgba(28, 31, 33, .2);*/
    /*}*/

    .course-content {
        float: none;
        width: 100%;
        box-shadow: none;
    }

    .course-nav-row {
        position: relative;
        padding: 16px 0 5px;
        border-bottom: 1px solid #edf1f2;
    }

    .course-nav-row .hd {
        width: 52px;
        height: 20px;
        line-height: 30px;
        font-weight: 700;
        font-size: 14px;
        color: #07111b;
        text-align: left;
    }

    .l {
        float: left;
    }

    .course-nav-row .bd {
        margin-left: 50px;
    }

    .course-nav-item {
        display: inline-block;
        margin: 0 4px;
    }

    .course-nav-item.on a {
        background: rgba(242, 13, 13, .06);
        border-radius: 6px;
        font-weight: 700;
        color: #F20D0D;
    }

    .course-nav-item a {
        display: block;
        line-height: 14px;
        margin-bottom: 10px;
        padding: 10px;
        font-size: 14px;
    }


</style>